<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="user-home-wrapper" *ngIf="accessToUserHome; else UserHomeNotAccesible">
  <div class="bpt-main-content-container" style="overflow: auto">
    <div class="version-display">
      eQMS {{ version }}
    </div>
    <div class="card">
      <app-user-home-document [userHomeCardsAccess]="userHomeCardsAccess" [dashboardData]="dashboardData"></app-user-home-document>
    </div>
    <div class="card">
      <app-user-home-training [userHomeCardsAccess]="userHomeCardsAccess" [dashboardData]="dashboardData"></app-user-home-training>
    </div>
  </div>

</div>

<ng-template #UserHomeNotAccesible>
  <app-error [errorMessage]="userHomeErrorMessage()"></app-error>
</ng-template>